// components/Comment.js

export default function Comment({ name, date, content }) {
  function formatTimeAgo(date) {
    const now = new Date();
    const diff = now - new Date(date);

    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (minutes < 60) {
      return `${minutes} dakika önce`;
    } else if (hours < 24) {
      return `${hours} saat önce`;
    } else {
      return new Date(date).toLocaleString();
    }
  }

  return (
    <div className="comment">
      <div className="comment-header">
        <strong>{name}</strong>
        <p className="comment-time">{formatTimeAgo(date)}</p>
      </div>
      <div className="comment-content">
        <p>{content}</p>
      </div>
      <hr />
    </div>
  );
}
